import { Product } from './products'

/** Replacement filter cartridges currently listed in the Pegasus online catalog. */
export const filterProducts: Product[] = [
  {
    name: 'Viking Spas replacement filter',
    sku: '14294',
    price: 56.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Filters/6ch940.jpg400x400.jpg',
    alt: 'Viking Spas replacement filter cartridge with blue end cap',
  },
  {
    name: "12649 2013-02/2023 680 Series Sundance Spas 50 sq' Filter",
    sku: '12649',
    price: 52.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Filters/c4950.jpg400x400.jpg',
    alt: 'Sundance Spas 680 Series 50 square foot replacement filter cartridge',
  },
  {
    name: "Sundance Spa Filter 125 sq'",
    sku: '12627',
    price: 115.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Filters/c8325.jpg400x400.jpg',
    alt: 'Sundance Spas 125 square foot replacement filter cartridge',
  },
  {
    name: "12628 1 Piece 780 Series Micro Clean Sundance Spa Filter 125Sq'",
    sku: '12628',
    price: 117.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Filters/c8326.jpg400x400.jpg',
    alt: 'Sundance Spas 780 Series Micro Clean 125 square foot replacement filter cartridge',
  },
  {
    name: '12629 780 Series Sundance Microclean Filter Cartridge 75sq ft',
    sku: '12629',
    price: 88.0,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Filters/6540-501ST-Filter.jpg400x400.jpg',
    alt: 'Sundance Spas 780 Series MicroClean 75 square foot filter cartridge',
  },
  {
    name: '14798 2009-2023 880 Series Filter: MicroClean Ultra INNER Core only',
    sku: '14798',
    price: 40.0,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Filters/6473-164ST-Filter.jpg400x400.jpg',
    alt: 'Sundance Spas 880 Series MicroClean Ultra inner core filter cartridge',
  },
  {
    name: '14799 2009-2023 880 Series MicroClean Ultra Filter OUTER only',
    sku: '14799',
    price: 70.0,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Filters/6473-165ST-Filter.jpg400x400.jpg',
    alt: 'Sundance Spas 880 Series MicroClean Ultra outer filter cartridge',
  },
  {
    name: '12626 780 Series Micro Clean Disposable filter',
    sku: '12626',
    price: 14.5,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/micro%20clean%20filter.jpg400x400.jpg',
    alt: 'Sundance Spas 780 Series Micro Clean disposable filter',
  },
]
